import *as dashboardTypes from "./DashboardActionTypes";
import axios from "axios";
import Cookies from "js-cookie";

const jwtToken = Cookies.get("jwt_token");
const userLogin = Cookies.get("UserLogin");

export const getUpdates = (updates) => {
    return {
        type: dashboardTypes.GET_UPDATES,
        payload: updates
    }
}

export const updateAdded = () => {
    return {
        type: dashboardTypes.ADD_UPDATE,
    }
}

export const showingLoader = (loaderStatus) => {
    return {
        type: dashboardTypes.SHOW_LOADER,
        payload: loaderStatus
    }
}

export const notificationsCalled = (notifications) => {
    return {
        type: dashboardTypes.CALL_NOTIFICATIONS,
        payload: notifications
    }
}
export const getOverduetasks = (alerts) => {
    return {
        type: dashboardTypes.GET_ALERTS,
        payload: alerts
    }
}
export const getPercentages = (percentage) => {
    return {
        type: dashboardTypes.GET_GROUP_PERCENTAGE,
        payload: percentage
    }
}

export const callNotifications = () => {
    return async (dispatch) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}DashBoard/PayrollUpdateStatus`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    }
                }
            )
            const notes = response.data;
            const temp = [];
            const strlength = notes.length;
            let i = strlength - 1;
            for (i; i >= 0; i--) {
                const email = notes[i].submitted_By.split('@')[0].replace('.', " ").replace(/[0-9]/g, "")
                const words = email.split(' ');
                const formattedEmail = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                temp.push({
                    description: notes[i].description,
                    id: notes[i].id,
                    status: notes[i].status,
                    submitted_By: formattedEmail,
                    title: notes[i].title,
                })
                // temp.push(notes[i])
            }
            // console.log(temp)
            dispatch(notificationsCalled(temp))
        }
        catch (error) {

        }
    }
}

export const loadUpdates = () => {
    return async (dispatch) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}DashBoard/getupdates`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    }
                }
            )
            const updates = response.data;
            const temp = [];
            const strlength = updates.length
            let i = strlength - 1;
            for (i; i >= 0; i--) {
                temp.push(updates[i])
            }
            dispatch(getUpdates(temp))
        }
        catch (error) {

        }
    }
}

export const addUpdate = (addText, currentdate) => {
    return async (dispatch) => {
        dispatch(showingLoader(false))
        try {
            let url = `${process.env.REACT_APP_BASE_URL}DashBoard/newupdate`;
            const adding = {
                "id": 0,
                "title": "payroll update",
                "description": addText,
                "postedTime": currentdate,
                "submitted_By": userLogin,
            };
            const response = await axios.post(url, adding, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            }
            )
            dispatch(updateAdded())
            dispatch(loadUpdates())
            dispatch(showingLoader(true))
            return response
        }
        catch (error) {
            return error
        }
    }

}

export const getAllAlerts = () => {
    return async (dispatch) => {
        try {
            let url = `${process.env.REACT_APP_BASE_URL}UserTask/Alerts`
            let data = []
            const response = await axios.post(url, data,
                {
                    headers: {
                        "content-type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    }
                }
            )
            const overduetasks = response.data;
            dispatch(getOverduetasks(overduetasks))
        }
        catch (error) {
            // console.log(error)
        }
    }
}

export const getTotalGroupPercentage = () => {
    return async (dispatch) => {
        try {
            let url = `${process.env.REACT_APP_BASE_URL}UserTask/GetPercentage`
            const response = await axios.get(url,
                {
                    headers: {
                        "content-type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    }
                }
            )
            const GroupPer = response.data.payload;
            const data = JSON.parse(GroupPer)
            dispatch(getPercentages(data))
        }
        catch (error) {
            // console.log(error)
        }
    }
}